export default "__VITE_ASSET__DNAeBDpH__"